import * as betprofessor from './DrawerHeader.styles.betprofessor';
import * as betroyale from './DrawerHeader.styles.betroyale';
import * as fiestabet from './DrawerHeader.styles.fiestabet';
import * as goldenrush from './DrawerHeader.styles.goldenrush';
import * as juicybet from './DrawerHeader.styles.juicybet';
import * as puntcity from './DrawerHeader.styles.puntcity';
import * as puntgenie from './DrawerHeader.styles.puntgenie';
import * as questbet from './DrawerHeader.styles.questbet';
import * as sterlingparker from './DrawerHeader.styles.sterlingparker';
import * as vikingbet from './DrawerHeader.styles.vikingbet';
import * as volcanobet from './DrawerHeader.styles.volcanobet';
import * as forsport from './DrawerHeader.styles.forsport';
import * as junglebet from './DrawerHeader.styles.junglebet';
import * as betstride from './DrawerHeader.styles.betstride';
import * as sugarcastle from './DrawerHeader.styles.sugarcastle';
import * as oldgill from './DrawerHeader.styles.oldgill';
import * as titanbet from './DrawerHeader.styles.titanbet';
import * as goldenbet888 from './DrawerHeader.styles.goldenbet888';
import * as gigabet from './DrawerHeader.styles.gigabet';
import * as bet777 from './DrawerHeader.styles.bet777';
import * as slambet from './DrawerHeader.styles.slambet';
import * as chromabet from './DrawerHeader.styles.chromabet';
import * as templebet from './DrawerHeader.styles.templebet';
import * as hyperbet from './DrawerHeader.styles.hyperbet';
import * as bet575 from './DrawerHeader.styles.bet575';
import * as betblast from './DrawerHeader.styles.betblast';
import * as magnumbet from './DrawerHeader.styles.magnumbet';
import * as pyramidbet from './DrawerHeader.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  bet777,
  junglebet,
  betstride,
  sugarcastle,
  oldgill,
  titanbet,
  goldenbet888,
  gigabet,
  slambet,
  chromabet,
  templebet,
  hyperbet,
  bet575,
  betblast,
  magnumbet,
  pyramidbet,
};
